import { useCallback } from 'react'
import type { MutationHook } from '@commerce/utils/types'
import useRemoveItem , { UseRemoveItem } from '@commerce/wishlist/use-remove-item'
import type { RemoveItemHook } from '@commerce/types/wishlist'
import useWishlist from './use-wishlist'
import Cookies from "js-cookie";
import {CUSTOMER_COOKIE} from "@framework/const";
import {useRouter} from "next/router";

export default useRemoveItem as UseRemoveItem<typeof handler>

export const handler: MutationHook<RemoveItemHook> = {
  fetchOptions: {
    url: '/my-account/favorites',
    method: 'DELETE',
  },
    async fetcher({ input: { customerToken, productId, }, options, fetch }) {

        return fetch({
            url: options.url + "/" + productId,
            method: options.method,
            headers: {
                'Authorization': 'Bearer ' + customerToken,
            }
        })
    },
  useHook:
    ({ fetch }) =>
    () => {
      //const { data: customer } = useCustomer()
      const router = useRouter();
      const customer = null;
      const { mutate } = useWishlist({ locale: router.locale! })

      return useCallback(
        async function addItem(item) {
          /*if (!customer) {
            // A signed customer is required in order to have a wishlist
            throw new CommerceError({
              message: 'Signed customer not found',
            })
          }*/

          // TODO: add validations before doing the fetch
          const data = await fetch({ input: { customerToken: Cookies.get(CUSTOMER_COOKIE)!, productId: item.productId } })
          await mutate()
          return data
        },
        [fetch, mutate, customer]
      )
    },
}
